import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsButton as Button } from './src/Button.js';
const { customElementClass, safeTagName } = safeDefineFsComponent.define(Button);
export const FsButton = customElementClass;
export const tagName = safeTagName;
//# sourceMappingURL=fs-button.js.map